/**
 * @desc 登出
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/accessToken/signOut`, {
      method: "POST",

      ...options,
    }),
  );
}
